module.exports = __webpack_public_path__ + "static/media/vote-btn.a62bb7c6.png";